// import React, { useEffect, useState, useRef } from "react";
// import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
// import * as Yup from "yup";
// import moment from "moment";
// import {
//   Modal,
//   Button,
//   Form,
//   Row,
//   Col,
//   InputGroup,
//   FormControl,
//   Card,
// } from "react-bootstrap";
// import { yupResolver } from "@hookform/resolvers/yup";
// import DatePicker from "react-datepicker";
// import { IconCalendarWeek, IconCurrencyDollar } from "@tabler/icons-react";
// import usePostRequest from "../../../hooks/usePostRequest";
// import {
//   API_ENDPOINTS,
//   handleKeyDown,
//   roundToMoney,
//   truncateFormat,
// } from "../../../constant/_constant";
// import { PDFDownloadLink } from "@react-pdf/renderer";
// import PackingSlipPdfDocument from "../PackageSlipPDF/Main";
// import { IconFileTypePdf } from "@tabler/icons-react";
// import { toast } from "react-toastify";
// import { pdf, BlobProvider } from "@react-pdf/renderer";
// import { useSelector } from "react-redux";
// import EmailSuggestions from "../../../components/EmailSuggestions";
// import PackingSlipAttachments from "../PackingSlipAttachments";
// import { usePostHog } from "@posthog/react";

// const PackingSlipComponent = ({
//   isPackageDetailsDialogOpen,
//   setIsPackageDetailsDialogOpen,
//   orderId,
//   onUpdateSuccess,
//   onUpdateError,
//   viewOnlyRecord,
//   isViewMode,
// }) => {
//   const user = useSelector((state) => state.auth.user);
//   const [packingSlipData, setPackingSlipData] = useState(null);
//   const [packingSlipClicked, setPackingSlipClicked] = useState(false);
//   const [showClin, setShowClin] = useState(false);
//   const [showGen, setShowGen] = useState(false);
//   const [selectedFromAddressOption, setSelectedFromAddressOption] =
//     useState("");
//   const [selectedToAddressOption, setSelectedToAddressOption] = useState("");
//   const [userEmails, setUserEmails] = useState([]);
//   const textAreaRefs = useRef([]);
//   const [viewEmailsKey, setViewEmailsKey] = useState(0);
//   const [pendingAttachments, setPendingAttachments] = useState([]);
//   const [showPreviewModal, setShowPreviewModal] = useState(false);
//   const [previewData, setPreviewData] = useState(null);
//   const posthog = usePostHog();

//   const { data: fetcheddata, postData: fetchOrder } = usePostRequest(
//     API_ENDPOINTS.GET_SINGLE_ORDER,
//   );

//   const row = fetcheddata?.data || [];

//   console.log("row", row);

//   useEffect(() => {
//     fetchOrder({ order_id: orderId, route_name: "packaging_slip" });
//   }, []);

//   const { isLoading: isgetLoading, postData: GetPackigSlip } = usePostRequest(
//     API_ENDPOINTS.GET_PACKING_SLIP,
//   );

//   const { isLoading: isGeneratingPDF, postData: GeneratePDF } = usePostRequest(
//     API_ENDPOINTS.GET_PDF_PACKING_SLIP,
//   );

//   const { isLoading: isUpdateLoading, postData: create_Update_Paking_SLIP } =
//     usePostRequest(API_ENDPOINTS.GENERATE_PACKING_SLIP);

//   const validationSchema = Yup.object().shape({
//     from_address: Yup.string().required("From Address is required"),
//     to_address: Yup.string().required("To Address is required"),
//     contract_number: Yup.string(),
//     shipping_method: Yup.string(),
//     preffered_email: Yup.string(),
//     tracking_number: Yup.string(),
//     ship_date: Yup.date().required("Ship Date is required"),
//     invoice_number: Yup.string(),
//     notification_emails: Yup.array().of(Yup.string().email("Invalid email")),
//     Delivery_Order_Number: Yup.string(),
//     purchase_order: Yup.string(),
//     delivery_order: Yup.string(),
//     amendment: Yup.string(),
//     carrier: Yup.string(),
//     shipping_cost: Yup.number(),
//     items: Yup.array().of(
//       Yup.object().shape({
//         auto_id: Yup.string(),
//         clin_id: Yup.string(),
//         sku_id: Yup.string().required("Part Number is required"),
//         description: Yup.string().nullable().optional(),
//         name: Yup.string().nullable().optional(),
//         quantity: Yup.number()
//           .required("Quantity is required")
//           .typeError("Quantity must be a number")
//           .min(0, "Quantity cannot be negative")
//           .test(
//             "max-quantity",
//             "Quantity exceeds available amount",
//             function (value, context) {
//               const index = context.path.match(/items\[(\d+)\]/)?.[1];
//               const items = context.options.context?.items || [];
//               const item = items[index];
//               if (
//                 !item ||
//                 typeof item.totalqty === "undefined" ||
//                 typeof item.packaging_slip_quantity === "undefined"
//               ) {
//                 return true; // Skip validation if item data is not yet available
//               }
//               const allowedQty = item.totalqty - item.packaging_slip_quantity;
//               return value <= allowedQty;
//             },
//           ),
//         customer_price: Yup.number()
//           .required("Unit Price is required")
//           .typeError("Unit Price must be a number"),
//         total_price: Yup.number()
//           .required("Total Cost is required")
//           .typeError("Total Cost must be a number"),
//       }),
//     ),
//   });

//   const [formContext, setFormContext] = useState({ items: [] });

//   const buildPreviewData = () => {
//     const data = getValues();

//     return {
//       // Server-generated — not available pre-submit
//       id: null,
//       created_by: null,
//       updatedAt: null,
//       createdAt: null,

//       // Mappable from form / row
//       order_id: row?.order_id || null,
//       from_address: data.from_address || "",
//       to_address: data.to_address || "",
//       ship_date: data.ship_date
//         ? moment(data.ship_date).format("YYYY-MM-DD")
//         : null,
//       contract_number: data.contract_number || "",
//       shipping_method: data.shipping_method || "",
//       tracking_number: data.tracking_number || "",
//       invoice_number: data.invoice_number || "",
//       deliver_to_customer: data.deliveryToCustomer === "YES" ? 1 : 0,
//       purchase_order: data.purchase_order || "",
//       amendment: data.amendment || "",
//       carrier: data.carrier || "",
//       shipping_cost: data.shipping_cost || 0,
//       delivery_order: data.delivery_order || "",
//       notes: data.notes || "",
//       notification_emails: Array.isArray(data.notification_emails)
//         ? data.notification_emails.join(",")
//         : data.notification_emails || "",
//       preffered_email: data.preffered_email || "salesLead",

//       // Only selected products (mirrors what API returns in products[])
//       products: data.items
//         .filter((item) => item.is_selected)
//         .map((item) => ({
//           ...item,
//           total_price: roundToMoney(
//             parseFloat(item.quantity) * parseFloat(item.customer_price),
//           ),
//           // total_price: parseFloat(
//           //   truncateFormat(
//           //     parseFloat(item.quantity) * parseFloat(item.customer_price),
//           //     2,
//           //   ),
//           // ),
//         })),

//       // Appended manually in onUpdateSlipSuccess — same logic here
//       sales_lead_name:
//         `${user?.first_name || ""} ${user?.last_name || ""}`.trim(),
//       sales_lead_email: user?.email || "",
//     };
//   };

//   const handlePreview = async () => {
//     const preview = buildPreviewData();

//     const pdfDoc = (
//       <PackingSlipPdfDocument
//         invoicedata={preview}
//         items={preview.products}
//         loggedInUser={user}
//       />
//     );

//     const blob = await pdf(pdfDoc).toBlob();
//     console.log("blobblob", blob);
//     const url = URL.createObjectURL(blob);
//     console.log("urlurl", url);
//     window.open(url, "_blank");
//   };

//   // const handlePreview = async () => {
//   //   const preview = buildPreviewData();
//   //   const fileName = `${File_Opportunity_Name}${preview.invoice_number}_PackingSlip.pdf`;

//   //   const pdfDoc = (
//   //     <PackingSlipPdfDocument
//   //       invoicedata={preview}
//   //       items={preview.products}
//   //       loggedInUser={user}
//   //     />
//   //   );

//   //   const blob = await pdf(pdfDoc).toBlob();
//   //   const url = URL.createObjectURL(blob);

//   //   const newWindow = window.open("", "_blank");
//   //   newWindow.document.write(`
//   //   <!DOCTYPE html>
//   //   <html>
//   //     <head>
//   //       <title>${fileName}</title>
//   //     </head>
//   //     <body style="margin:0;padding:0;height:100vh;">
//   //       <embed src="${url}" type="application/pdf" width="100%" height="100%" />
//   //     </body>
//   //   </html>
//   // `);
//   //   newWindow.document.close();
//   // };

//   const {
//     register,
//     handleSubmit,
//     control,
//     setValue,
//     getValues,
//     watch,
//     formState: { errors },
//     reset,
//   } = useForm({
//     resolver: yupResolver(validationSchema, { context: formContext }),
//     defaultValues: {
//       items: [],
//     },
//   });

//   const {
//     fields: itemFields,
//     append,
//     remove,
//     replace,
//   } = useFieldArray({
//     control,
//     name: "items",
//   });

//   const watchedItems = useWatch({
//     control,
//     name: "items",
//   });

//   const items = watch("items");

//   useEffect(() => {
//     const anySelected = watchedItems?.some((item) => item?.is_selected);
//     setShowGen(anySelected);
//   }, [watchedItems]);

//   console.log("packingSlipData", packingSlipData);
//   console.log("useruseruseruseruser", user);

//   const onUpdateSlipSuccess = async (res) => {
//     posthog.capture("packing_slip_generated", {
//       invoice_number: res?.data?.invoice_number,
//       created_date: res?.data?.createdAt,
//       created_by: user?.email,
//       sales_lead_email: res?.data?.sales_lead_email,
//     });

//     const updatedPackingSlipData = {
//       ...res?.data,
//       sales_lead_name: row?.sales_lead_name || "",
//       sales_lead_email: row?.sales_lead_email || "",
//     };

//     setPackingSlipData(updatedPackingSlipData);
//     toast.success(res?.message || "Packing slip generated successfully");
//     setPackingSlipClicked(true);

//     try {
//       // Generate PDF blob
//       const pdfDoc = (
//         <PackingSlipPdfDocument
//           invoicedata={updatedPackingSlipData}
//           items={getValues("items").filter((item) => item.is_selected)}
//           loggedInUser={user}
//         />
//       );

//       const pdfBlob = await pdf(pdfDoc).toBlob();

//       // Prepare FormData to send file + JSON
//       const formData = new FormData();

//       // PDF file

//       formData.append(
//         "packing_slip_data",
//         JSON.stringify(updatedPackingSlipData),
//       );

//       // PDF blob
//       formData.append(
//         "pdf",
//         new File([pdfBlob], `PackingSlip_${row?.invoice_no || orderId}.pdf`, {
//           type: "application/pdf",
//         }),
//       );

//       // Pending attachments
//       pendingAttachments.forEach((file) => {
//         formData.append("pdf", file);
//       });
//       // formData.append(
//       //   "pdf",
//       //   pdfBlob,
//       //   `PackingSlip_${row?.invoice_no || orderId}.pdf`,
//       // );

//       // formData.append(
//       //   "packing_slip_data",
//       //   JSON.stringify(updatedPackingSlipData),
//       // );

//       // pendingAttachments.forEach((file) => {
//       //   formData.append("pdf", file, file.name);
//       // });
//       // Other simple fields
//       // formData.append("order_id", res?.data?.order_id);
//       // formData.append("packing_slip_id", res?.data?.id);

//       // Append the entire original res object (your example JSON)
//       // formData.append("packing_slip_response", JSON.stringify(res));

//       // Or if backend only wants the inner data:

//       // Send to backend
//       await GeneratePDF(formData);

//       console.log("PDF + response sent to backend");
//     } catch (error) {
//       console.error("Failed to generate or send PDF:", error);
//       // toast.error("Packing slip created, but failed to save PDF on server");
//     }
//   };

//   // const onUpdateSlipSuccess = (res) => {
//   //   // setPackingSlipData(res?.data);
//   //   setPackingSlipData({
//   //     ...res?.data,
//   //     sales_lead_name: row?.sales_lead_name || "",
//   //     sales_lead_email: row?.sales_lead_email || "",
//   //   });
//   //   toast.success(res?.message);
//   //   setPackingSlipClicked(true);
//   // };

//   // console.log("viewOnlyRecordviewOnlyRecord", viewOnlyRecord);

//   useEffect(() => {
//     if (isViewMode && viewOnlyRecord) {
//       setValue("from_address", viewOnlyRecord.from_address ?? "");
//       setValue("to_address", viewOnlyRecord.to_address ?? "");
//       setValue("contract_number", viewOnlyRecord.contract_number ?? "");
//       setValue("shipping_method", viewOnlyRecord.shipping_method ?? "");
//       setValue("preffered_email", viewOnlyRecord.preffered_email ?? "");
//       setValue("tracking_number", viewOnlyRecord.tracking_number ?? "");
//       const emailsString = viewOnlyRecord.notification_emails;
//       const emailsArray = emailsString
//         ? emailsString
//             .split(",")
//             .map((e) => e.trim())
//             .filter(Boolean)
//         : [];
//       setValue("notification_emails", emailsArray);
//       setValue(
//         "ship_date",
//         viewOnlyRecord.ship_date ? new Date(viewOnlyRecord.ship_date) : null,
//       );
//       setValue("invoice_number", viewOnlyRecord.invoice_number ?? "");
//       setValue("purchase_order", viewOnlyRecord.purchase_order ?? "");
//       setValue("delivery_order", viewOnlyRecord.delivery_order ?? "");
//       setValue("amendment", viewOnlyRecord.amendment ?? "");
//       setValue("carrier", viewOnlyRecord.carrier ?? "");
//       setValue("shipping_cost", viewOnlyRecord.shipping_cost ?? 0);
//       setValue(
//         "deliveryToCustomer",
//         viewOnlyRecord.deliver_to_customer === 1 ? "YES" : "NO",
//       );
//       const items = viewOnlyRecord.products.map((product) => ({
//         auto_id: product.auto_id || "",
//         sku_id: product.sku_display_name || "",
//         clin_id: product.clin_id || "",
//         name: product.name || "",
//         clin_id: product.clin_id || "",
//         description: product.description || "",
//         quantity: product.quantity || 0,
//         customer_price: parseFloat(product.customer_price) || 0,
//         total_price: parseFloat(product.total_price) || 0,
//         raw_sku_id: product?.raw_sku_id || "",
//       }));
//       setValue("items", items);
//     }
//   }, [isViewMode, viewOnlyRecord, setValue]);

//   const onUpdateSlipError = (error) => {
//     console.log("error", error);
//     toast.error(error?.message || "Error generating packing slip");
//   };

//   const onSubmit = (data) => {
//     console.log("Packing Slip form data", data);
//     const payload = {
//       sales_lead_name: `${user?.first_name || ""} ${
//         user?.last_name || ""
//       }`.trim(),
//       sales_lead_email: user?.email || "",
//       ...data,
//       notification_emails: Array.isArray(data?.notification_emails)
//         ? data.notification_emails.join(",")
//         : data?.notification_emails || "",
//       delivery_order: data?.delivery_order || "",
//       notes: data?.notes || "",
//       ship_date: data?.ship_date
//         ? moment(data.ship_date).format("YYYY-MM-DD")
//         : null,
//       order_id: row?.order_id,
//       deliver_to_customer: data?.deliveryToCustomer === "YES" ? 1 : 0,
//       products: data.items
//         .filter((item) => item.is_selected === true)
//         .map((item) => ({
//           ...item,
//           total_price: roundToMoney(
//             parseFloat(item.quantity) * parseFloat(item.customer_price),
//           ),
//           // total_price:
//           //   parseFloat(item.quantity) * parseFloat(item.customer_price),
//         })),
//     };

//     create_Update_Paking_SLIP(payload, onUpdateSlipSuccess, onUpdateSlipError);
//   };

//   useEffect(() => {
//     if (row?.notification_emails) {
//       const emailsFromRow =
//         typeof row.notification_emails === "string"
//           ? row.notification_emails
//               .split(",")
//               .map((e) => e.trim())
//               .filter(Boolean)
//           : Array.isArray(row.notification_emails)
//             ? row.notification_emails
//             : [];

//       const validEmails = emailsFromRow.filter((email) =>
//         /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
//       );

//       setUserEmails(validEmails);
//     }
//   }, [row?.notification_emails]);

//   useEffect(() => {
//     reset({
//       deliveryToCustomer: "YES",
//       contract_number: row?.contract_vehicle_rfq_id || "",
//       tracking_number: row?.orderExtra?.tracking_number || "",
//       ship_date: row?.orderExtra?.ship_date
//         ? moment(row.orderExtra.ship_date).toDate()
//         : new Date(),
//       purchase_order: row?.orderExtra?.purchase_order || "",
//       delivery_order: row?.orderExtra?.delivery_order || "",
//       amendment: row?.orderExtra?.amendment || "",
//       carrier: row?.orderExtra?.carrier || "",
//       shipping_method: row?.shipping_method || "",
//       invoice_number: row?.order_id || "",
//       shipping_cost: row?.orderExtra?.shipping_cost_packing || 0,
//     });
//     // if (row && !isViewMode) {
//     //   setValue("deliveryToCustomer", "YES");
//     //   setValue("contract_number", row?.contract_vehicle_rfq_id || "");
//     //   setValue("tracking_number", row?.orderExtra?.tracking_number || "");
//     //   setValue(
//     //     "ship_date",
//     //     moment(row?.orderExtra?.ship_date).format("MM/DD/YYYY") || new Date()
//     //   );
//     //   setValue("purchase_order", row?.orderExtra?.purchase_order || "");
//     //   setValue("delivery_order", row?.orderExtra?.delivery_order || "");
//     //   setValue("amendment", row?.orderExtra?.amendment || "");
//     //   setValue("carrier", row?.orderExtra?.carrier || "");

//     //   setValue(
//     //     "shipping_method",
//     //     row?.shipping_method ? row?.shipping_method : ""
//     //   );
//     //   setValue("invoice_number", row?.order_id || "");
//     //   setValue("shipping_cost", row?.orderExtra?.shipping_cost_packing || 0);
//     // }
//   }, [row, isViewMode, setValue]);

//   const onSuccess = (res) => {
//     console.log("response", res);
//     console.log("row?.shipping_method", row?.shipping_method);
//     const slipData = res?.data;

//     setValue("deliveryToCustomer", "YES");
//     setValue("contract_number", row?.ContractType?.Rfq?.rfq_id || "");
//     setValue(
//       "shipping_method",
//       row?.shipping_method ? row?.shipping_method : "",
//     );
//     if (slipData) {
//       // setValue(
//       //   "from_address",
//       //   slipData.from_address ||
//       //     "Aspetto Inc.\n3428 Hwy 297 North\nVidalia, GA 30474"
//       // );
//       // setValue(
//       //   "to_address",
//       //   slipData.to_address || row?.orderShipping?.address || ""
//       // );
//       // setValue("contract_number", slipData.contract_number || "");
//       // setValue("shipping_method", slipData.shipping_method || "");
//       setValue(
//         "shipping_method_detail",
//         slipData.shipping_method_detail || "N/A",
//       );
//       setValue("purchase_order", slipData.purchase_order || "");
//       setValue("amendment", slipData.amendment || "");
//       setValue("carrier", slipData.carrier || "");
//       setValue("shipping_cost", slipData.shipping_cost || 0);
//       setValue(
//         "ship_date",
//         slipData.ship_date ? new Date(slipData.ship_date) : moment().toDate(),
//       );
//       setValue("tracking_number", slipData.tracking_number || "");
//       setValue("invoice_number", slipData.invoice_number || row?.invoice_no);
//     }
//   };

//   const onError = (error) => {
//     if (!getValues("from_address")) {
//       // setValue(
//       //   "from_address",
//       //   "Aspetto Inc.\n3428 Hwy 297 North\nVidalia, GA 30474"
//       // );
//     }
//     // if (!getValues("to_address")) {
//     //   setValue("to_address", row?.orderShipping?.address || "N/A");
//     // }
//     if (!getValues("contract_number")) {
//       setValue("contract_number", "");
//     }
//     if (!getValues("shipping_method")) {
//       setValue("shipping_method", row?.shipping_method || "");
//     }
//     if (!getValues("shipping_method_detail")) {
//       setValue("shipping_method_detail", row?.shipping_method_detail || "N/A");
//     }
//     if (!getValues("purchase_order")) {
//       setValue("purchase_order", "");
//     }
//     if (!getValues("delivery_order")) {
//       setValue("delivery_order", "");
//     }
//     if (!getValues("amendment")) {
//       setValue("amendment", "");
//     }
//     if (!getValues("carrier")) {
//       setValue("carrier", "");
//     }
//     if (!getValues("shipping_cost")) {
//       setValue("shipping_cost", 0);
//     }
//     if (!getValues("ship_date")) {
//       const today = moment().toDate();
//       setValue("ship_date", today);
//     }
//     if (!getValues("tracking_number")) {
//       setValue("tracking_number", "");
//     }
//     if (!getValues("invoice_number")) {
//       setValue("invoice_number", row?.invoice_no);
//     }
//   };

//   // useEffect(() => {
//   //   GetPackigSlip({ order_id: row?.order_id }, onSuccess, onError);
//   // }, [row?.order_id]);

//   useEffect(() => {
//     if (
//       row?.OrderProductSales &&
//       !isViewMode &&
//       row.OrderProductSales.length > 0
//     ) {
//       const items = row.OrderProductSales.map((skurow) => {
//         const quantity = parseInt(skurow.quantity) || 0;
//         const packagingQty = parseInt(skurow.packaging_slip_quantity) || 0;
//         const allowedQty = Math.max(quantity - packagingQty, 0);
//         return {
//           vendor_name: skurow?.Vendor?.display_name,
//           auto_id: skurow.raw_sku_id || "",
//           sku_id: skurow.sku_display_name || "",
//           name: skurow.name || skurow.Product.name,
//           description: skurow.description || "",
//           clin_id: skurow.clin_id || "",
//           totalqty: quantity,
//           quantity: allowedQty,
//           packaging_slip_quantity: packagingQty,
//           customer_price: parseFloat(skurow.customer_price) || 0,
//           total_price: roundToMoney(
//             allowedQty * (parseFloat(skurow.customer_price) || 0),
//           ),
//           // total_price:
//           //   parseFloat(allowedQty * (parseFloat(skurow.customer_price) || 0)) ||
//           //   0,
//           raw_sku_id: skurow?.raw_sku_id || "",
//         };
//       });
//       // setValue("items", items);
//       replace(items);
//       setFormContext({ items });
//     }
//   }, [row?.OrderProductSales, setValue, isViewMode]);

//   const adjustTextAreaHeight = (index) => {
//     const textArea = textAreaRefs.current[index];
//     if (textArea) {
//       textArea.style.height = "auto";
//       textArea.style.height = `${textArea.scrollHeight}px`;
//     }
//   };

//   useEffect(() => {
//     itemFields.forEach((_, index) => {
//       adjustTextAreaHeight(index);
//     });
//   }, [itemFields]);

//   const OP_arr = String(`order`).split(".");
//   for (var i = 0; i < OP_arr?.length; i++) {
//     OP_arr[i] = OP_arr[i].charAt(0).toUpperCase() + OP_arr[i].slice(1);
//   }
//   const File_Opportunity_Name = OP_arr.join(" ");

//   const addressOptions = [
//     ...(row?.OrderVendors?.map((vendor, index) => ({
//       label: vendor?.Vendor?.display_name,
//       address: vendor?.Vendor?.VendorContact?.address || "",
//     })) || []),
//     row?.orderShipping?.name && {
//       label: row?.orderShipping?.name,
//       address: row?.orderShipping?.address,
//     },
//     row?.orderKo?.name && {
//       label: row?.orderKo?.name,
//       address: row?.orderKo?.address,
//     },
//     row?.orderBilling?.name && {
//       label: row?.orderBilling?.name,
//       address: row?.orderBilling?.address,
//     },
//     {
//       label: "Aspetto",
//       address:
//         "Aspetto, Inc.\n150 Riverside pkwy. Suite 203\nFredericksburg, VA 22406 USA\n+1 540-547-8487\ninfo@aspettoinc.com",
//     },
//   ].filter(Boolean);

//   const addressOptionsFrom = [
//     ...(row?.OrderVendors?.map((vendor, index) => ({
//       label: vendor?.Vendor?.display_name,
//       address: vendor?.Vendor?.VendorContact?.address || "",
//     })) || []),
//     {
//       label: "Aspetto",
//       address:
//         "Aspetto, Inc.\n150 Riverside pkwy. Suite 203\nFredericksburg, VA 22406 USA\n+1 540-547-8487\ninfo@aspettoinc.com",
//     },
//   ].filter(Boolean);

//   useEffect(() => {
//     const subscription = watch((value) => {
//       console.log("Current form values:", value);
//     });
//     return () => subscription.unsubscribe();
//   }, [watch]);

//   return (
//     <Modal
//       scrollable
//       show={isPackageDetailsDialogOpen}
//       onHide={() => {
//         setIsPackageDetailsDialogOpen(false);
//         setPackingSlipClicked(false);
//       }}
//       size="lg"
//       className="skusearch"
//       dialogClassName="modal-90vw"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>Packing Slip</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form
//           onSubmit={handleSubmit(onSubmit, (errors) => {
//             console.log("❌ Form validation failed. Errors:", errors);
//             // Log each field error individually for easier debugging
//             Object.entries(errors).forEach(([field, error]) => {
//               if (field === "items" && Array.isArray(error)) {
//                 error.forEach((itemError, index) => {
//                   if (itemError) {
//                     Object.entries(itemError).forEach(
//                       ([itemField, itemFieldError]) => {
//                         console.log(
//                           `❌ items[${index}].${itemField}:`,
//                           itemFieldError?.message,
//                         );
//                       },
//                     );
//                   }
//                 });
//               } else {
//                 console.log(`❌ ${field}:`, error?.message);
//               }
//             });
//           })}
//         >
//           <Row className="mb-3 mt-3">
//             <Form.Group as={Col}>
//               <div
//                 style={{ display: "flex", gap: "2px 18px", flexWrap: "wrap" }}
//               >
//                 <Form.Label
//                   className="d-inline-block d-sm-inline w-100 w-sm-auto"
//                   // style={{ fontWeight: "bold" }}
//                 >
//                   Deliver to customer:
//                 </Form.Label>

//                 <Form.Check>
//                   <Form.Check.Input
//                     type="radio"
//                     id="deliveryToCustomerYes"
//                     value="YES"
//                     {...register("deliveryToCustomer")}
//                     disabled={isViewMode}
//                   />
//                   <Form.Check.Label htmlFor="deliveryToCustomerYes">
//                     YES
//                   </Form.Check.Label>
//                   <Form.Check>
//                     <Form.Check.Input
//                       type="radio"
//                       id="deliveryToCustomerNo"
//                       value="NO"
//                       {...register("deliveryToCustomer")}
//                       disabled={isViewMode}
//                     />

//                     <Form.Check.Label htmlFor="deliveryToCustomerNo">
//                       NO
//                     </Form.Check.Label>
//                   </Form.Check>
//                 </Form.Check>
//               </div>
//             </Form.Group>
//           </Row>
//           <Row>
//             <Col lg={6} md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Choose From Address</Form.Label>
//                 <InputGroup>
//                   <Form.Select
//                     disabled={isViewMode}
//                     value={selectedFromAddressOption}
//                     onChange={(e) => {
//                       const selectedLabel = e.target.value;
//                       setSelectedFromAddressOption(selectedLabel);

//                       const selected = addressOptionsFrom.find(
//                         (opt) => opt.label === selectedLabel,
//                       );

//                       // ---- NEW: clear if address is null or missing ----
//                       if (!selected?.address) {
//                         setValue("from_address", ""); // clear textarea
//                       } else {
//                         setValue("from_address", selected.address);
//                       }
//                     }}
//                   >
//                     <option value="">Select an address</option>
//                     {addressOptionsFrom.map((opt, index) => (
//                       <option key={index} value={opt.label}>
//                         {opt.label}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             <Col lg={6} md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Choose To Address</Form.Label>
//                 <InputGroup>
//                   <Form.Select
//                     value={selectedToAddressOption}
//                     disabled={isViewMode}
//                     onChange={(e) => {
//                       const selectedLabel = e.target.value;
//                       setSelectedToAddressOption(selectedLabel);

//                       const selected = addressOptions.find(
//                         (opt) => opt.label === selectedLabel,
//                       );

//                       // ---- NEW: clear if address is null or missing ----
//                       if (!selected?.address) {
//                         setValue("to_address", ""); // clear textarea
//                       } else {
//                         setValue("to_address", selected.address);
//                       }
//                     }}
//                   >
//                     <option value="">Select an address</option>
//                     {addressOptions.map((opt, index) => (
//                       <option key={index} value={opt.label}>
//                         {opt.label}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </InputGroup>
//               </Form.Group>
//             </Col>
//             {/* <Col lg={6} md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Choose From Address</Form.Label>
//                 <InputGroup>
//                   <Form.Select
//                     value={selectedFromAddressOption}
//                     onChange={(e) => {
//                       const selectedLabel = e.target.value;
//                       setSelectedFromAddressOption(selectedLabel);
//                       const selected = addressOptions.find(
//                         (opt) => opt.label === selectedLabel
//                       );
//                       if (selected?.address) {
//                         setValue("from_address", selected.address);
//                       }
//                     }}
//                   >
//                     <option value="">Select an address</option>
//                     {addressOptions.map((opt, index) => (
//                       <option key={index} value={opt.label}>
//                         {opt.label}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             <Col lg={6} md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Choose To Address</Form.Label>
//                 <InputGroup>
//                   <Form.Select
//                     value={selectedToAddressOption}
//                     onChange={(e) => {
//                       const selectedLabel = e.target.value;
//                       setSelectedToAddressOption(selectedLabel);
//                       const selected = addressOptions.find(
//                         (opt) => opt.label === selectedLabel
//                       );
//                       if (selected?.address) {
//                         setValue("to_address", selected.address);
//                       }
//                     }}
//                   >
//                     <option value="">Select an address</option>
//                     {addressOptions.map((opt, index) => (
//                       <option key={index} value={opt.label}>
//                         {opt.label}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </InputGroup>
//               </Form.Group>
//             </Col> */}
//             <Col lg={6} md={6}>
//               <Form.Group controlId="fromAddress">
//                 <Form.Label className="required">From Address</Form.Label>
//                 <Form.Control
//                   isInvalid={!!errors.from_address}
//                   as="textarea"
//                   disabled={isViewMode}
//                   {...register("from_address")}
//                   style={{
//                     height: "auto",
//                     minHeight: "80px",
//                     resize: "none",
//                   }}
//                   onInput={(e) => {
//                     e.target.style.height = "auto";
//                     e.target.style.height = `${e.target.scrollHeight}px`;
//                   }}
//                   placeholder="Enter From Address"
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.from_address?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col lg={6} md={6}>
//               <Form.Group controlId="toAddress">
//                 <Form.Label className="required">To Address</Form.Label>
//                 <Form.Control
//                   isInvalid={!!errors.to_address}
//                   as="textarea"
//                   disabled={isViewMode}
//                   {...register("to_address")}
//                   style={{
//                     height: "auto",
//                     minHeight: "80px",
//                     resize: "none",
//                   }}
//                   onInput={(e) => {
//                     e.target.style.height = "auto";
//                     e.target.style.height = `${e.target.scrollHeight}px`;
//                   }}
//                   placeholder="Enter To Address"
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.to_address?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col lg={3} md={3}>
//               <Form.Group controlId="contractNumber" className="mt-3">
//                 <Form.Label>Contract Number</Form.Label>
//                 <Form.Control
//                   type="text"
//                   disabled={isViewMode}
//                   {...register("contract_number")}
//                   isInvalid={!!errors.contract_number}
//                   placeholder="Enter Contract Number"
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.contract_number?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col lg={3} md={3}>
//               <Form.Group className="mb-3 mt-3">
//                 <Form.Label>Shipping Method</Form.Label>
//                 <Form.Control
//                   type="text"
//                   disabled={isViewMode}
//                   {...register("shipping_method")}
//                   isInvalid={!!errors.shipping_method}
//                   placeholder="Enter Shipping Method"
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.shipping_method?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col lg={3} md={3}>
//               <Form.Group controlId="trackingNumber" className="mt-3">
//                 <Form.Label>Tracking Number</Form.Label>
//                 <Form.Control
//                   type="text"
//                   disabled={isViewMode}
//                   {...register("tracking_number")}
//                   isInvalid={!!errors.tracking_number}
//                   placeholder="Enter Tracking Number"
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.tracking_number?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col lg={3} md={3}>
//               <Form.Group className="mb-3 mt-3">
//                 <Form.Label className="required">Ship Date</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconCalendarWeek stroke={1} />
//                   </InputGroup.Text>
//                   <Controller
//                     name="ship_date"
//                     control={control}
//                     disabled={isViewMode}
//                     defaultValue={new Date()}
//                     rules={{ required: "Ship Date is required" }}
//                     render={({ field }) => (
//                       <DatePicker
//                         {...field}
//                         selected={
//                           field.value ? new Date(field.value) : new Date()
//                         }
//                         onChange={(date) => field.onChange(date)}
//                         dateFormat="MM/dd/yyyy"
//                         // minDate={new Date()}
//                         placeholderText="Select Date"
//                         className="form-control required"
//                       />
//                     )}
//                   />
//                 </InputGroup>
//                 {errors.ship_date && (
//                   <span className="text-danger">
//                     {errors.ship_date.message}
//                   </span>
//                 )}
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col lg={3} md={3}>
//               <Form.Group controlId="invoiceNumber">
//                 <Form.Label>Invoice Number</Form.Label>
//                 <Form.Control
//                   type="text"
//                   disabled={isViewMode}
//                   {...register("invoice_number")}
//                   isInvalid={!!errors.invoice_number}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.invoice_number?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col lg={3} md={3}>
//               <Form.Group controlId="purchaseOrder">
//                 <Form.Label>Purchase Order</Form.Label>
//                 <Form.Control
//                   type="text"
//                   disabled={isViewMode}
//                   {...register("purchase_order")}
//                   isInvalid={!!errors.purchase_order}
//                   placeholder="Enter Purchase Order"
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.purchase_order?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col lg={3} md={3}>
//               <Form.Group controlId="deliveryOrder">
//                 <Form.Label>Delivery Order</Form.Label>
//                 <Form.Control
//                   type="text"
//                   disabled={isViewMode}
//                   {...register("delivery_order")}
//                   isInvalid={!!errors.delivery_order}
//                   placeholder="Enter Delivery Order"
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.delivery_order?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col lg={3} md={3}>
//               <Form.Group controlId="amendment">
//                 <Form.Label>Amendment</Form.Label>
//                 <Form.Control
//                   disabled={isViewMode}
//                   type="text"
//                   {...register("amendment")}
//                   isInvalid={!!errors.amendment}
//                   placeholder="Enter Amendment"
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.amendment?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row>
//             <Col lg={3} md={3}>
//               <Form.Group controlId="carrierDetails" className="mt-3">
//                 <Form.Label>Carrier</Form.Label>
//                 <Form.Control
//                   type="text"
//                   disabled={isViewMode}
//                   {...register("carrier")}
//                   isInvalid={!!errors.carrier}
//                   placeholder="Enter Carrier"
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.carrier?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col lg={3} md={3}>
//               <Form.Group controlId="shippingCost" className="mt-3">
//                 <Form.Label>Shipping Cost</Form.Label>
//                 <Form.Control
//                   type="text"
//                   disabled={isViewMode}
//                   onKeyDown={handleKeyDown}
//                   {...register("shipping_cost")}
//                   isInvalid={!!errors.shipping_cost}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.shipping_cost?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col lg={3} md={3}>
//               <Form.Group className="mb-3 mt-3">
//                 <Form.Label>Notes</Form.Label>
//                 <InputGroup>
//                   <Form.Control
//                     as="textarea"
//                     disabled={isViewMode}
//                     {...register("notes")}
//                     style={{
//                       height: "auto",
//                       minHeight: "80px",
//                       resize: "none",
//                     }}
//                     onInput={(e) => {
//                       e.target.style.height = "auto";
//                       e.target.style.height = `${e.target.scrollHeight}px`;
//                     }}
//                     placeholder="Enter Notes"
//                   />
//                 </InputGroup>
//                 {errors.notes && (
//                   <span className="text-danger">{errors.notes.message}</span>
//                 )}
//               </Form.Group>
//             </Col>
//             <Col lg={3} md={3}>
//               <Form.Group className="mb-3 mt-3">
//                 <Form.Label>Person's Name</Form.Label>
//                 <InputGroup>
//                   <Form.Select
//                     {...register("preffered_email")}
//                     disabled={isViewMode}
//                   >
//                     {/* <option value={""}>Select a method</option> */}
//                     <option value={"salesLead"}>Sales Lead</option>
//                     <option value={"loggedIn"}>Self</option>
//                   </Form.Select>
//                 </InputGroup>
//                 <Form.Control.Feedback type="invalid">
//                   {errors.preffered_email?.message}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* {!isViewMode && (
//             <Row>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label className="">Notification Email(s)</Form.Label>
//                   <Controller
//                     name="notification_emails"
//                     control={control}
//                     disabled={isViewMode}
//                     defaultValue={[]}
//                     render={({ field }) => (
//                       <EmailSuggestions
//                         {...field}
//                         suggestionsSource={userEmails}
//                         validate={(email) =>
//                           /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
//                         }
//                         errorMessage="Invalid email format"
//                         placeholder="Enter email and press Enter"
//                       />
//                     )}
//                   />

//                   {errors.notification_emails && (
//                     <span className="text-danger">
//                       {errors.notification_emails.message}
//                     </span>
//                   )}
//                 </Form.Group>
//               </Col>
//             </Row>
//           )}
//           {!isViewMode && (
//             <div className="mt-3">
//               <PackingSlipAttachments
//                 maxFiles={5}
//                 maxFileSize={25}
//                 onFilesChange={(files) => setPendingAttachments(files)}
//               />
//             </div>
//           )} */}
//           <div className="drag_section mt-3">
//             {itemFields.map((item, index) => (
//               <Card key={item.id} className="mb-3 ">
//                 <Card.Body>
//                   <Row className="grag_flex_row p-3">
//                     <Col className="small_drag_column mob_50">
//                       <Form.Group>
//                         <Form.Label className="">INCLUDE</Form.Label>
//                         <Form.Text>
//                           <Form.Check
//                             type="checkbox"
//                             id={`items[${index}].is_selected`}
//                             {...register(`items[${index}].is_selected`)}
//                             disabled={
//                               item.totalqty - item.packaging_slip_quantity ===
//                                 0 || isViewMode
//                             }
//                           />
//                         </Form.Text>
//                       </Form.Group>
//                     </Col>
//                     {showClin && (
//                       <Col className="mid_drag_column mob_50">
//                         <Form.Group>
//                           <Form.Label className="">CLIN</Form.Label>
//                           <InputGroup>
//                             <Form.Control
//                               {...register(`items[${index}].auto_id`)}
//                               defaultValue={item.auto_id}
//                               placeholder="CLIN"
//                               disabled={true}
//                             />
//                           </InputGroup>
//                           {errors.items?.[index]?.auto_id && (
//                             <span className="text-danger">
//                               {errors.items[index].auto_id.message}
//                             </span>
//                           )}
//                         </Form.Group>
//                       </Col>
//                     )}
//                     <Col className="mid_drag_column mob_50">
//                       <Form.Group>
//                         <Form.Label className="">CLIN ID</Form.Label>
//                         <InputGroup>
//                           <Form.Control
//                             {...register(`items[${index}].clin_id`)}
//                             defaultValue={item.clin_id}
//                             placeholder="CLIN ID"
//                             disabled={
//                               item.totalqty - item.packaging_slip_quantity ===
//                                 0 || isViewMode
//                             }
//                           />
//                         </InputGroup>
//                         {errors.items?.[index]?.clin_id && (
//                           <span className="text-danger">
//                             {errors.items[index].clin_id.message}
//                           </span>
//                         )}
//                       </Form.Group>
//                     </Col>
//                     {showClin && (
//                       <>
//                         <Col className="mid_drag_column mob_50">
//                           <Form.Group>
//                             <Form.Label className="">Product Name</Form.Label>
//                             <InputGroup>
//                               <Form.Control
//                                 {...register(`items[${index}].name`)}
//                                 defaultValue={item.name}
//                                 placeholder="Name"
//                                 disabled={true}
//                               />
//                             </InputGroup>
//                             {errors.items?.[index]?.name && (
//                               <span className="text-danger">
//                                 {errors.items[index].name.message}
//                               </span>
//                             )}
//                           </Form.Group>
//                         </Col>
//                         <Col className="mid_drag_column mob_50">
//                           <Form.Group>
//                             <Form.Label className="">Raw Sku ID</Form.Label>
//                             <InputGroup>
//                               <Form.Control
//                                 {...register(`items[${index}].raw_sku_id`)}
//                                 defaultValue={item.raw_sku_id}
//                                 placeholder="Name"
//                                 disabled={true}
//                               />
//                             </InputGroup>
//                             {errors.items?.[index]?.raw_sku_id && (
//                               <span className="text-danger">
//                                 {errors.items[index].raw_sku_id.message}
//                               </span>
//                             )}
//                           </Form.Group>
//                         </Col>
//                       </>
//                     )}
//                     <Col className="mid_drag_column mob_50">
//                       <Form.Group>
//                         <Form.Label className="">Product Number</Form.Label>
//                         <InputGroup>
//                           <Form.Control
//                             {...register(`items[${index}].sku_id`)}
//                             defaultValue={item.sku_id}
//                             placeholder="Part Number"
//                             disabled={true}
//                           />
//                         </InputGroup>
//                         {errors.items?.[index]?.sku_id && (
//                           <span className="text-danger">
//                             {errors.items[index].sku_id.message}
//                           </span>
//                         )}
//                       </Form.Group>
//                     </Col>

//                     <Col className="mob_100">
//                       <Form.Group>
//                         <Form.Label className="">Item Description</Form.Label>
//                         <InputGroup>
//                           <Form.Control
//                             disabled={
//                               item.totalqty - item.packaging_slip_quantity ===
//                                 0 || isViewMode
//                             }
//                             as="textarea"
//                             {...register(`items[${index}].description`)}
//                             defaultValue={item.description}
//                             placeholder="Description"
//                             ref={(el) => {
//                               textAreaRefs.current[index] = el;
//                               adjustTextAreaHeight(index);
//                             }}
//                             style={{
//                               resize: "none",
//                               overflow: "hidden",
//                             }}
//                             // onChange={() => adjustTextAreaHeight(index)}
//                             onChange={(e) => {
//                               const newValue = e.target.value;
//                               setValue(`items.${index}.description`, newValue);
//                               adjustTextAreaHeight(index);
//                             }}
//                           />
//                         </InputGroup>
//                         {errors.items?.[index]?.description && (
//                           <span className="text-danger">
//                             {errors.items[index].description.message}
//                           </span>
//                         )}
//                       </Form.Group>
//                     </Col>

//                     <Col className="small_drag_column mob_50">
//                       <Form.Group>
//                         <Form.Label>
//                           QTY{" "}
//                           {!isViewMode && (
//                             <>
//                               (Max:{" "}
//                               {item.totalqty - item.packaging_slip_quantity})
//                             </>
//                           )}
//                         </Form.Label>

//                         <InputGroup>
//                           <Form.Control
//                             disabled={
//                               item.totalqty - item.packaging_slip_quantity ===
//                                 0 || isViewMode
//                             }
//                             type="number"
//                             {...register(`items[${index}].quantity`, {
//                               valueAsNumber: true,
//                             })}
//                             defaultValue={item.quantity}
//                             placeholder="0"
//                             max={item.totalqty - item.packaging_slip_quantity}
//                             onChange={(e) => {
//                               const qty = parseFloat(e.target.value) || 0;
//                               const allowedQty =
//                                 item.totalqty - item.packaging_slip_quantity;
//                               const validQty = Math.min(qty, allowedQty);
//                               if (qty > allowedQty) {
//                                 toast.error(
//                                   `Maximum allowed quantity is ${allowedQty}`,
//                                 );
//                                 setValue(`items.${index}.quantity`, validQty);
//                               } else {
//                                 setValue(`items.${index}.quantity`, validQty);
//                               }
//                               const price =
//                                 parseFloat(
//                                   getValues(`items.${index}.customer_price`),
//                                 ) || 0;
//                               const total = roundToMoney(validQty * price);
//                               setValue(`items.${index}.total_price`, total);
//                               // const total = parseFloat(
//                               //   truncateFormat(validQty * price, 2),
//                               // );
//                               // setValue(`items.${index}.total_price`, total);
//                             }}
//                           />
//                         </InputGroup>
//                         {errors.items?.[index]?.quantity && (
//                           <span className="text-danger">
//                             {errors.items[index].quantity.message}
//                           </span>
//                         )}
//                       </Form.Group>
//                     </Col>

//                     <Col className="mob_50">
//                       <Form.Group>
//                         <Form.Label className="">Unit Price</Form.Label>
//                         <InputGroup>
//                           <InputGroup.Text>
//                             <IconCurrencyDollar stroke={2} />
//                           </InputGroup.Text>
//                           <Form.Control
//                             type="number"
//                             disabled={true}
//                             step="any"
//                             {...register(`items[${index}].customer_price`, {
//                               valueAsNumber: true,
//                             })}
//                             defaultValue={item.customer_price}
//                             placeholder="0.00"
//                           />
//                         </InputGroup>
//                         {errors.items?.[index]?.customer_price && (
//                           <span className="text-danger">
//                             {errors.items[index].customer_price.message}
//                           </span>
//                         )}
//                       </Form.Group>
//                     </Col>

//                     <Col className="mob_50">
//                       <Form.Group>
//                         <Form.Label className="">Total Cost</Form.Label>
//                         <InputGroup>
//                           <InputGroup.Text>
//                             <IconCurrencyDollar stroke={2} />
//                           </InputGroup.Text>
//                           <Form.Control
//                             type="number"
//                             step="any"
//                             disabled={true}
//                             {...register(`items[${index}].total_price`, {
//                               valueAsNumber: true,
//                             })}
//                             defaultValue={item.total_price}
//                             placeholder="0.00"
//                             readOnly
//                           />
//                         </InputGroup>
//                         {errors.items?.[index]?.total_price && (
//                           <span className="text-danger">
//                             {errors.items[index].total_price.message}
//                           </span>
//                         )}
//                       </Form.Group>
//                     </Col>
//                   </Row>
//                 </Card.Body>
//               </Card>
//             ))}
//             <div className="totle_costing mt-3">
//               <h6>
//                 Sub Total:
//                 <span>
//                   <IconCurrencyDollar />
//                   {truncateFormat(
//                     items?.reduce(
//                       (sum, item) => sum + (parseFloat(item?.total_price) || 0),
//                       0,
//                     ) || 0,
//                     2,
//                   )}
//                 </span>
//               </h6>
//             </div>
//           </div>

//           <div className="mb-3 mt-3">
//             {/* Show Generate button only when not in View Mode and something is selected */}
//             {!isViewMode && showGen && (
//               <>
//                 <Button
//                   variant="secondary"
//                   type="button"
//                   className="me-2"
//                   onClick={handlePreview}
//                 >
//                   Preview <IconFileTypePdf />
//                 </Button>
//                 <Button variant="primary" type="submit">
//                   Generate <IconFileTypePdf />
//                 </Button>
//               </>
//             )}

//             {/* Always show Download button in View Mode */}
//             {isViewMode && (
//               <PDFDownloadLink
//                 component="button"
//                 color="secondary"
//                 document={
//                   <PackingSlipPdfDocument
//                     invoicedata={viewOnlyRecord}
//                     items={getValues("items")}
//                     loggedInUser={user}
//                   />
//                 }
//                 fileName={`${File_Opportunity_Name}${row.invoice_no}_PackingSlip.pdf`}
//               >
//                 {({ blob, url, loading, error }) => (
//                   <span
//                     className="btn btn-success ms-2 d-inline-flex align-items-center"
//                     style={{ gap: "6px" }}
//                   >
//                     {loading ? "Loading..." : "Download"}
//                   </span>
//                 )}
//               </PDFDownloadLink>
//             )}

//             {/* Show Download after generating (normal mode) */}
//             {!isViewMode && packingSlipClicked && (
//               <PDFDownloadLink
//                 component="button"
//                 color="secondary"
//                 document={
//                   <PackingSlipPdfDocument
//                     invoicedata={packingSlipData}
//                     items={getValues("items")}
//                     loggedInUser={user}
//                   />
//                 }
//                 fileName={`${File_Opportunity_Name}${row.invoice_no}_PackingSlip.pdf`}
//               >
//                 {({ blob, url, loading, error }) => (
//                   <span
//                     className="btn btn-success ms-2 d-inline-flex align-items-center"
//                     style={{ gap: "6px" }}
//                   >
//                     {loading ? "Loading..." : "Download"}
//                   </span>
//                 )}
//               </PDFDownloadLink>
//             )}
//           </div>

//           {/* <div className="mb-3 mt-3">
//             {showGen && (
//               <>
//                 <Button variant="primary" type="submit">
//                   Generate <IconFileTypePdf />
//                 </Button>

//                 {packingSlipClicked && (
//                   <PDFDownloadLink
//                     component="button"
//                     color="secondary"
//                     document={
//                       <PackingSlipPdfDocument
//                         invoicedata={
//                           isViewMode ? viewOnlyRecord : packingSlipData
//                         }
//                         items={getValues("items")}
//                         loggedInUser={user}
//                       />
//                     }
//                     fileName={`${File_Opportunity_Name}${row.invoice_no}_PackingSlip.pdf`}
//                   >
//                     {({ blob, url, loading, error }) => (
//                       <span
//                         className="btn btn-success ms-2 d-inline-flex align-items-center"
//                         style={{ gap: "6px" }}
//                       >
//                         {loading ? "Loading..." : "Download"}
//                       </span>
//                     )}
//                   </PDFDownloadLink>
//                 )}
//               </>
//             )}
//           </div> */}
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default PackingSlipComponent;

import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import * as Yup from "yup";
import moment from "moment";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  InputGroup,
  FormControl,
  Card,
} from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import DatePicker from "react-datepicker";
import { IconCalendarWeek, IconCurrencyDollar } from "@tabler/icons-react";
import usePostRequest from "../../../hooks/usePostRequest";
import {
  API_ENDPOINTS,
  handleKeyDown,
  roundToMoney,
  truncateFormat,
} from "../../../constant/_constant";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PackingSlipPdfDocument from "../PackageSlipPDF/Main";
import { IconFileTypePdf } from "@tabler/icons-react";
import { toast } from "react-toastify";
import { pdf, BlobProvider } from "@react-pdf/renderer";
import { useSelector } from "react-redux";
import EmailSuggestions from "../../../components/EmailSuggestions";
import PackingSlipAttachments from "../PackingSlipAttachments";
import { usePostHog } from "@posthog/react";

const PackingSlipComponent = ({
  isPackageDetailsDialogOpen,
  setIsPackageDetailsDialogOpen,
  orderId,
  onUpdateSuccess,
  onUpdateError,
  viewOnlyRecord,
  isViewMode,
}) => {
  const user = useSelector((state) => state.auth.user);
  const [packingSlipData, setPackingSlipData] = useState(null);
  const [packingSlipClicked, setPackingSlipClicked] = useState(false);
  const [showClin, setShowClin] = useState(false);
  const [showGen, setShowGen] = useState(false);
  const [selectedFromAddressOption, setSelectedFromAddressOption] =
    useState("");
  const [selectedToAddressOption, setSelectedToAddressOption] = useState("");
  const [userEmails, setUserEmails] = useState([]);
  const textAreaRefs = useRef([]);
  const [viewEmailsKey, setViewEmailsKey] = useState(0);
  const [pendingAttachments, setPendingAttachments] = useState([]);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const posthog = usePostHog();

  const { data: fetcheddata, postData: fetchOrder } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_ORDER,
  );

  const row = fetcheddata?.data || [];

  console.log("row", row);

  useEffect(() => {
    fetchOrder({ order_id: orderId, route_name: "packaging_slip" });
  }, []);

  const { isLoading: isgetLoading, postData: GetPackigSlip } = usePostRequest(
    API_ENDPOINTS.GET_PACKING_SLIP,
  );

  const { isLoading: isGeneratingPDF, postData: GeneratePDF } = usePostRequest(
    API_ENDPOINTS.GET_PDF_PACKING_SLIP,
  );

  const { isLoading: isUpdateLoading, postData: create_Update_Paking_SLIP } =
    usePostRequest(API_ENDPOINTS.GENERATE_PACKING_SLIP);

  const validationSchema = Yup.object().shape({
    from_address: Yup.string().required("From Address is required"),
    to_address: Yup.string().required("To Address is required"),
    contract_number: Yup.string(),
    shipping_method: Yup.string(),
    preffered_email: Yup.string(),
    tracking_number: Yup.string(),
    ship_date: Yup.date().required("Ship Date is required"),
    invoice_number: Yup.string(),
    notification_emails: Yup.array().of(Yup.string().email("Invalid email")),
    Delivery_Order_Number: Yup.string(),
    purchase_order: Yup.string(),
    delivery_order: Yup.string(),
    amendment: Yup.string(),
    carrier: Yup.string(),
    shipping_cost: Yup.number(),
    items: Yup.array().of(
      Yup.object().shape({
        auto_id: Yup.string(),
        clin_id: Yup.string(),
        sku_id: Yup.string().required("Part Number is required"),
        description: Yup.string().nullable().optional(),
        name: Yup.string().nullable().optional(),
        quantity: Yup.number()
          .required("Quantity is required")
          .typeError("Quantity must be a number")
          .min(0, "Quantity cannot be negative")
          .test(
            "max-quantity",
            "Quantity exceeds available amount",
            function (value, context) {
              const index = context.path.match(/items\[(\d+)\]/)?.[1];
              const items = context.options.context?.items || [];
              const item = items[index];
              if (
                !item ||
                typeof item.totalqty === "undefined" ||
                typeof item.packaging_slip_quantity === "undefined"
              ) {
                return true; // Skip validation if item data is not yet available
              }
              const allowedQty = item.totalqty - item.packaging_slip_quantity;
              return value <= allowedQty;
            },
          ),
        customer_price: Yup.number()
          .required("Unit Price is required")
          .typeError("Unit Price must be a number"),
        total_price: Yup.number()
          .required("Total Cost is required")
          .typeError("Total Cost must be a number"),
      }),
    ),
  });

  const [formContext, setFormContext] = useState({ items: [] });

  const buildPreviewData = () => {
    const data = getValues();

    return {
      // Server-generated — not available pre-submit
      id: null,
      created_by: null,
      updatedAt: null,
      createdAt: null,

      // Mappable from form / row
      order_id: row?.order_id || null,
      from_address: data.from_address || "",
      to_address: data.to_address || "",
      ship_date: data.ship_date
        ? moment(data.ship_date).format("YYYY-MM-DD")
        : null,
      contract_number: data.contract_number || "",
      shipping_method: data.shipping_method || "",
      tracking_number: data.tracking_number || "",
      invoice_number: data.invoice_number || "",
      deliver_to_customer: data.deliveryToCustomer === "YES" ? 1 : 0,
      purchase_order: data.purchase_order || "",
      amendment: data.amendment || "",
      carrier: data.carrier || "",
      shipping_cost: data.shipping_cost || 0,
      delivery_order: data.delivery_order || "",
      notes: data.notes || "",
      notification_emails: Array.isArray(data.notification_emails)
        ? data.notification_emails.join(",")
        : data.notification_emails || "",
      preffered_email: data.preffered_email || "salesLead",

      // Only selected products (mirrors what API returns in products[])
      products: data.items
        .filter((item) => item.is_selected)
        .map((item) => ({
          ...item,
          total_price: roundToMoney(
            parseFloat(item.quantity) * parseFloat(item.customer_price),
          ),
        })),

      // Appended manually in onUpdateSlipSuccess — same logic here
      sales_lead_name:
        `${user?.first_name || ""} ${user?.last_name || ""}`.trim(),
      sales_lead_email: user?.email || "",
    };
  };

  const handlePreview = async () => {
    const preview = buildPreviewData();

    const pdfDoc = (
      <PackingSlipPdfDocument
        invoicedata={preview}
        items={preview.products}
        loggedInUser={user}
      />
    );

    const blob = await pdf(pdfDoc).toBlob();
    console.log("blobblob", blob);
    const url = URL.createObjectURL(blob);
    console.log("urlurl", url);
    window.open(url, "_blank");
  };

  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema, { context: formContext }),
    defaultValues: {
      items: [],
    },
  });

  const {
    fields: itemFields,
    append,
    remove,
    replace,
  } = useFieldArray({
    control,
    name: "items",
  });

  const watchedItems = useWatch({
    control,
    name: "items",
  });

  const items = watch("items");

  useEffect(() => {
    const anySelected = watchedItems?.some((item) => item?.is_selected);
    setShowGen(anySelected);
  }, [watchedItems]);

  console.log("packingSlipData", packingSlipData);
  console.log("useruseruseruseruser", user);

  const onUpdateSlipSuccess = async (res) => {
    posthog.capture("packing_slip_generated", {
      invoice_number: res?.data?.invoice_number,
      created_date: res?.data?.createdAt,
      created_by: user?.email,
      sales_lead_email: res?.data?.sales_lead_email,
    });

    const updatedPackingSlipData = {
      ...res?.data,
      sales_lead_name: row?.sales_lead_name || "",
      sales_lead_email: row?.sales_lead_email || "",
    };

    setPackingSlipData(updatedPackingSlipData);
    toast.success(res?.message || "Packing slip generated successfully");
    setPackingSlipClicked(true);

    try {
      // Generate PDF blob
      const pdfDoc = (
        <PackingSlipPdfDocument
          invoicedata={updatedPackingSlipData}
          items={getValues("items").filter((item) => item.is_selected)}
          loggedInUser={user}
        />
      );

      const pdfBlob = await pdf(pdfDoc).toBlob();

      // Prepare FormData to send file + JSON
      const formData = new FormData();

      // PDF file

      formData.append(
        "packing_slip_data",
        JSON.stringify(updatedPackingSlipData),
      );

      // PDF blob
      formData.append(
        "pdf",
        new File([pdfBlob], `PackingSlip_${row?.order_id || orderId}.pdf`, {
          type: "application/pdf",
        }),
      );

      // Pending attachments
      pendingAttachments.forEach((file) => {
        formData.append("pdf", file);
      });

      // Send to backend
      await GeneratePDF(formData);

      console.log("PDF + response sent to backend");
    } catch (error) {
      console.error("Failed to generate or send PDF:", error);
    }
  };

  // const onUpdateSlipSuccess = (res) => {
  //   // setPackingSlipData(res?.data);
  //   setPackingSlipData({
  //     ...res?.data,
  //     sales_lead_name: row?.sales_lead_name || "",
  //     sales_lead_email: row?.sales_lead_email || "",
  //   });
  //   toast.success(res?.message);
  //   setPackingSlipClicked(true);
  // };

  // console.log("viewOnlyRecordviewOnlyRecord", viewOnlyRecord);

  useEffect(() => {
    if (isViewMode && viewOnlyRecord) {
      setValue("from_address", viewOnlyRecord.from_address ?? "");
      setValue("to_address", viewOnlyRecord.to_address ?? "");
      setValue("contract_number", viewOnlyRecord.contract_number ?? "");
      setValue("shipping_method", viewOnlyRecord.shipping_method ?? "");
      setValue("preffered_email", viewOnlyRecord.preffered_email ?? "");
      setValue("tracking_number", viewOnlyRecord.tracking_number ?? "");
      const emailsString = viewOnlyRecord.notification_emails;
      const emailsArray = emailsString
        ? emailsString
            .split(",")
            .map((e) => e.trim())
            .filter(Boolean)
        : [];
      setValue("notification_emails", emailsArray);
      setValue(
        "ship_date",
        viewOnlyRecord.ship_date ? new Date(viewOnlyRecord.ship_date) : null,
      );
      setValue("invoice_number", viewOnlyRecord.invoice_number ?? "");
      setValue("purchase_order", viewOnlyRecord.purchase_order ?? "");
      setValue("delivery_order", viewOnlyRecord.delivery_order ?? "");
      setValue("amendment", viewOnlyRecord.amendment ?? "");
      setValue("carrier", viewOnlyRecord.carrier ?? "");
      setValue("shipping_cost", viewOnlyRecord.shipping_cost ?? 0);
      setValue(
        "deliveryToCustomer",
        viewOnlyRecord.deliver_to_customer === 1 ? "YES" : "NO",
      );
      const items = viewOnlyRecord.products.map((product) => ({
        auto_id: product.auto_id || "",
        sku_id: product.sku_display_name || "",
        clin_id: product.clin_id || "",
        name: product.name || "",
        clin_id: product.clin_id || "",
        description: product.description || "",
        quantity: product.quantity || 0,
        customer_price: parseFloat(product.customer_price) || 0,
        total_price: parseFloat(product.total_price) || 0,
        raw_sku_id: product?.raw_sku_id || "",
      }));
      setValue("items", items);
    }
  }, [isViewMode, viewOnlyRecord, setValue]);

  const onUpdateSlipError = (error) => {
    console.log("error", error);
    toast.error(error?.message || "Error generating packing slip");
  };

  const onSubmit = (data) => {
    console.log("Packing Slip form data", data);
    const payload = {
      sales_lead_name: `${user?.first_name || ""} ${
        user?.last_name || ""
      }`.trim(),
      sales_lead_email: user?.email || "",
      ...data,
      notification_emails: Array.isArray(data?.notification_emails)
        ? data.notification_emails.join(",")
        : data?.notification_emails || "",
      delivery_order: data?.delivery_order || "",
      notes: data?.notes || "",
      ship_date: data?.ship_date
        ? moment(data.ship_date).format("YYYY-MM-DD")
        : null,
      order_id: row?.order_id,
      deliver_to_customer: data?.deliveryToCustomer === "YES" ? 1 : 0,
      products: data.items
        .filter((item) => item.is_selected === true)
        .map((item) => ({
          ...item,
          total_price: roundToMoney(
            parseFloat(item.quantity) * parseFloat(item.customer_price),
          ),
          // total_price:
          //   parseFloat(item.quantity) * parseFloat(item.customer_price),
        })),
    };

    create_Update_Paking_SLIP(payload, onUpdateSlipSuccess, onUpdateSlipError);
  };

  useEffect(() => {
    if (row?.notification_emails) {
      const emailsFromRow =
        typeof row.notification_emails === "string"
          ? row.notification_emails
              .split(",")
              .map((e) => e.trim())
              .filter(Boolean)
          : Array.isArray(row.notification_emails)
            ? row.notification_emails
            : [];

      const validEmails = emailsFromRow.filter((email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
      );

      setUserEmails(validEmails);
    }
  }, [row?.notification_emails]);

  useEffect(() => {
    reset({
      deliveryToCustomer: "YES",
      contract_number: row?.contract_vehicle_rfq_id || "",
      tracking_number: row?.orderExtra?.tracking_number || "",
      ship_date: row?.orderExtra?.ship_date
        ? moment(row.orderExtra.ship_date).toDate()
        : new Date(),
      purchase_order: row?.orderExtra?.purchase_order || "",
      delivery_order: row?.orderExtra?.delivery_order || "",
      amendment: row?.orderExtra?.amendment || "",
      carrier: row?.orderExtra?.carrier || "",
      shipping_method: row?.shipping_method || "",
      invoice_number: row?.order_id || "",
      shipping_cost: row?.orderExtra?.shipping_cost_packing || 0,
    });
  }, [row, isViewMode, setValue]);

  const onSuccess = (res) => {
    // Not using this function anywhere
    console.log("response", res);
    console.log("row?.shipping_method", row?.shipping_method);
    const slipData = res?.data;

    setValue("deliveryToCustomer", "YES");
    setValue("contract_number", row?.ContractType?.Rfq?.rfq_id || "");
    setValue(
      "shipping_method",
      row?.shipping_method ? row?.shipping_method : "",
    );
    if (slipData) {
      setValue(
        "shipping_method_detail",
        slipData.shipping_method_detail || "N/A",
      );
      setValue("purchase_order", slipData.purchase_order || "");
      setValue("amendment", slipData.amendment || "");
      setValue("carrier", slipData.carrier || "");
      setValue("shipping_cost", slipData.shipping_cost || 0);
      setValue(
        "ship_date",
        slipData.ship_date ? new Date(slipData.ship_date) : moment().toDate(),
      );
      setValue("tracking_number", slipData.tracking_number || "");
      setValue("invoice_number", slipData.invoice_number || row?.invoice_no);
    }
  };

  const onError = (error) => {
    // Not using this function anywhere
    if (!getValues("from_address")) {
      // setValue(
      //   "from_address",
      //   "Aspetto Inc.\n3428 Hwy 297 North\nVidalia, GA 30474"
      // );
    }
    if (!getValues("contract_number")) {
      setValue("contract_number", "");
    }
    if (!getValues("shipping_method")) {
      setValue("shipping_method", row?.shipping_method || "");
    }
    if (!getValues("shipping_method_detail")) {
      setValue("shipping_method_detail", row?.shipping_method_detail || "N/A");
    }
    if (!getValues("purchase_order")) {
      setValue("purchase_order", "");
    }
    if (!getValues("delivery_order")) {
      setValue("delivery_order", "");
    }
    if (!getValues("amendment")) {
      setValue("amendment", "");
    }
    if (!getValues("carrier")) {
      setValue("carrier", "");
    }
    if (!getValues("shipping_cost")) {
      setValue("shipping_cost", 0);
    }
    if (!getValues("ship_date")) {
      const today = moment().toDate();
      setValue("ship_date", today);
    }
    if (!getValues("tracking_number")) {
      setValue("tracking_number", "");
    }
    if (!getValues("invoice_number")) {
      setValue("invoice_number", row?.invoice_no);
    }
  };

  // useEffect(() => {
  //   GetPackigSlip({ order_id: row?.order_id }, onSuccess, onError);
  // }, [row?.order_id]);

  useEffect(() => {
    if (
      row?.OrderProductSales &&
      !isViewMode &&
      row.OrderProductSales.length > 0
    ) {
      const items = row.OrderProductSales.map((skurow) => {
        const quantity = parseFloat(skurow.quantity) || 0;
        const packagingQty = parseFloat(skurow.packaging_slip_quantity) || 0;

        // const allowedQty = Math.max(quantity - packagingQty, 0);
        const allowedQty = Number(
          Math.max(quantity - packagingQty, 0).toFixed(7),
        );
        // const quantity = parseInt(skurow.quantity) || 0;
        // const packagingQty = parseInt(skurow.packaging_slip_quantity) || 0;
        // const allowedQty = Math.max(quantity - packagingQty, 0);
        return {
          vendor_name: skurow?.Vendor?.display_name,
          auto_id: skurow.raw_sku_id || "",
          sku_id: skurow.sku_display_name || "",
          name: skurow.name || skurow.Product.name,
          description: skurow.description || "",
          clin_id: skurow.clin_id || "",
          totalqty: quantity,
          quantity: allowedQty,
          packaging_slip_quantity: packagingQty,
          customer_price: parseFloat(skurow.customer_price) || 0,
          total_price: roundToMoney(
            allowedQty * (parseFloat(skurow.customer_price) || 0),
          ),
          // total_price:
          //   parseFloat(allowedQty * (parseFloat(skurow.customer_price) || 0)) ||
          //   0,
          raw_sku_id: skurow?.raw_sku_id || "",
        };
      });
      // setValue("items", items);
      replace(items);
      setFormContext({ items });
    }
  }, [row?.OrderProductSales, setValue, isViewMode]);

  const adjustTextAreaHeight = (index) => {
    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.style.height = "auto";
      textArea.style.height = `${textArea.scrollHeight}px`;
    }
  };

  useEffect(() => {
    itemFields.forEach((_, index) => {
      adjustTextAreaHeight(index);
    });
  }, [itemFields]);

  const OP_arr = String(`order`).split(".");
  for (var i = 0; i < OP_arr?.length; i++) {
    OP_arr[i] = OP_arr[i].charAt(0).toUpperCase() + OP_arr[i].slice(1);
  }
  const File_Opportunity_Name = OP_arr.join(" ");

  const addressOptions = [
    ...(row?.OrderVendors?.map((vendor, index) => ({
      label: vendor?.Vendor?.display_name,
      address: vendor?.Vendor?.VendorContact?.address || "",
    })) || []),
    row?.orderShipping?.name && {
      label: row?.orderShipping?.name,
      address: row?.orderShipping?.address,
    },
    row?.orderKo?.name && {
      label: row?.orderKo?.name,
      address: row?.orderKo?.address,
    },
    row?.orderBilling?.name && {
      label: row?.orderBilling?.name,
      address: row?.orderBilling?.address,
    },
    {
      label: "Aspetto",
      address:
        "Aspetto, Inc.\n150 Riverside pkwy. Suite 203\nFredericksburg, VA 22406 USA\n+1 540-547-8487\ninfo@aspettoinc.com",
    },
  ].filter(Boolean);

  const addressOptionsFrom = [
    ...(row?.OrderVendors?.map((vendor, index) => ({
      label: vendor?.Vendor?.display_name,
      address: vendor?.Vendor?.VendorContact?.address || "",
    })) || []),
    {
      label: "Aspetto",
      address:
        "Aspetto, Inc.\n150 Riverside pkwy. Suite 203\nFredericksburg, VA 22406 USA\n+1 540-547-8487\ninfo@aspettoinc.com",
    },
  ].filter(Boolean);

  useEffect(() => {
    const subscription = watch((value) => {
      console.log("Current form values:", value);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <Modal
      scrollable
      show={isPackageDetailsDialogOpen}
      onHide={() => {
        setIsPackageDetailsDialogOpen(false);
        setPackingSlipClicked(false);
      }}
      size="lg"
      className="skusearch"
      dialogClassName="modal-90vw"
    >
      <Modal.Header closeButton>
        <Modal.Title>Packing Slip</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          onSubmit={handleSubmit(onSubmit, (errors) => {
            console.log("❌ Form validation failed. Errors:", errors);
            // Log each field error individually for easier debugging
            Object.entries(errors).forEach(([field, error]) => {
              if (field === "items" && Array.isArray(error)) {
                error.forEach((itemError, index) => {
                  if (itemError) {
                    Object.entries(itemError).forEach(
                      ([itemField, itemFieldError]) => {
                        console.log(
                          `❌ items[${index}].${itemField}:`,
                          itemFieldError?.message,
                        );
                      },
                    );
                  }
                });
              } else {
                console.log(`❌ ${field}:`, error?.message);
              }
            });
          })}
        >
          <Row className="mb-3 mt-3">
            <Form.Group as={Col}>
              <div
                style={{ display: "flex", gap: "2px 18px", flexWrap: "wrap" }}
              >
                <Form.Label
                  className="d-inline-block d-sm-inline w-100 w-sm-auto"
                  // style={{ fontWeight: "bold" }}
                >
                  Deliver to customer:
                </Form.Label>

                <Form.Check>
                  <Form.Check.Input
                    type="radio"
                    id="deliveryToCustomerYes"
                    value="YES"
                    {...register("deliveryToCustomer")}
                    disabled={isViewMode}
                  />
                  <Form.Check.Label htmlFor="deliveryToCustomerYes">
                    YES
                  </Form.Check.Label>
                  <Form.Check>
                    <Form.Check.Input
                      type="radio"
                      id="deliveryToCustomerNo"
                      value="NO"
                      {...register("deliveryToCustomer")}
                      disabled={isViewMode}
                    />

                    <Form.Check.Label htmlFor="deliveryToCustomerNo">
                      NO
                    </Form.Check.Label>
                  </Form.Check>
                </Form.Check>
              </div>
            </Form.Group>
          </Row>
          <Row>
            <Col lg={6} md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Choose From Address</Form.Label>
                <InputGroup>
                  <Form.Select
                    disabled={isViewMode}
                    value={selectedFromAddressOption}
                    onChange={(e) => {
                      const selectedLabel = e.target.value;
                      setSelectedFromAddressOption(selectedLabel);

                      const selected = addressOptionsFrom.find(
                        (opt) => opt.label === selectedLabel,
                      );

                      // ---- NEW: clear if address is null or missing ----
                      if (!selected?.address) {
                        setValue("from_address", ""); // clear textarea
                      } else {
                        setValue("from_address", selected.address);
                      }
                    }}
                  >
                    <option value="">Select an address</option>
                    {addressOptionsFrom.map((opt, index) => (
                      <option key={index} value={opt.label}>
                        {opt.label}
                      </option>
                    ))}
                  </Form.Select>
                </InputGroup>
              </Form.Group>
            </Col>

            <Col lg={6} md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Choose To Address</Form.Label>
                <InputGroup>
                  <Form.Select
                    value={selectedToAddressOption}
                    disabled={isViewMode}
                    onChange={(e) => {
                      const selectedLabel = e.target.value;
                      setSelectedToAddressOption(selectedLabel);

                      const selected = addressOptions.find(
                        (opt) => opt.label === selectedLabel,
                      );

                      // ---- NEW: clear if address is null or missing ----
                      if (!selected?.address) {
                        setValue("to_address", ""); // clear textarea
                      } else {
                        setValue("to_address", selected.address);
                      }
                    }}
                  >
                    <option value="">Select an address</option>
                    {addressOptions.map((opt, index) => (
                      <option key={index} value={opt.label}>
                        {opt.label}
                      </option>
                    ))}
                  </Form.Select>
                </InputGroup>
              </Form.Group>
            </Col>

            <Col lg={6} md={6}>
              <Form.Group controlId="fromAddress">
                <Form.Label className="required">From Address</Form.Label>
                <Form.Control
                  isInvalid={!!errors.from_address}
                  as="textarea"
                  disabled={isViewMode}
                  {...register("from_address")}
                  style={{
                    height: "auto",
                    minHeight: "80px",
                    resize: "none",
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                  }}
                  placeholder="Enter From Address"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.from_address?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col lg={6} md={6}>
              <Form.Group controlId="toAddress">
                <Form.Label className="required">To Address</Form.Label>
                <Form.Control
                  isInvalid={!!errors.to_address}
                  as="textarea"
                  disabled={isViewMode}
                  {...register("to_address")}
                  style={{
                    height: "auto",
                    minHeight: "80px",
                    resize: "none",
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                  }}
                  placeholder="Enter To Address"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.to_address?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={3} md={3}>
              <Form.Group controlId="contractNumber" className="mt-3">
                <Form.Label>Contract Number</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isViewMode}
                  {...register("contract_number")}
                  isInvalid={!!errors.contract_number}
                  placeholder="Enter Contract Number"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.contract_number?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col lg={3} md={3}>
              <Form.Group className="mb-3 mt-3">
                <Form.Label>Shipping Method</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isViewMode}
                  {...register("shipping_method")}
                  isInvalid={!!errors.shipping_method}
                  placeholder="Enter Shipping Method"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shipping_method?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col lg={3} md={3}>
              <Form.Group controlId="trackingNumber" className="mt-3">
                <Form.Label>Tracking Number</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isViewMode}
                  {...register("tracking_number")}
                  isInvalid={!!errors.tracking_number}
                  placeholder="Enter Tracking Number"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.tracking_number?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col lg={3} md={3}>
              <Form.Group className="mb-3 mt-3">
                <Form.Label className="required">Ship Date</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconCalendarWeek stroke={1} />
                  </InputGroup.Text>
                  <Controller
                    name="ship_date"
                    control={control}
                    disabled={isViewMode}
                    defaultValue={new Date()}
                    rules={{ required: "Ship Date is required" }}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        selected={
                          field.value ? new Date(field.value) : new Date()
                        }
                        onChange={(date) => field.onChange(date)}
                        dateFormat="MM/dd/yyyy"
                        // minDate={new Date()}
                        placeholderText="Select Date"
                        className="form-control required"
                      />
                    )}
                  />
                </InputGroup>
                {errors.ship_date && (
                  <span className="text-danger">
                    {errors.ship_date.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={3} md={3}>
              <Form.Group controlId="invoiceNumber">
                <Form.Label>Invoice Number</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isViewMode}
                  {...register("invoice_number")}
                  isInvalid={!!errors.invoice_number}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.invoice_number?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col lg={3} md={3}>
              <Form.Group controlId="purchaseOrder">
                <Form.Label>Purchase Order</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isViewMode}
                  {...register("purchase_order")}
                  isInvalid={!!errors.purchase_order}
                  placeholder="Enter Purchase Order"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.purchase_order?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col lg={3} md={3}>
              <Form.Group controlId="deliveryOrder">
                <Form.Label>Delivery Order</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isViewMode}
                  {...register("delivery_order")}
                  isInvalid={!!errors.delivery_order}
                  placeholder="Enter Delivery Order"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.delivery_order?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col lg={3} md={3}>
              <Form.Group controlId="amendment">
                <Form.Label>Amendment</Form.Label>
                <Form.Control
                  disabled={isViewMode}
                  type="text"
                  {...register("amendment")}
                  isInvalid={!!errors.amendment}
                  placeholder="Enter Amendment"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.amendment?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col lg={3} md={3}>
              <Form.Group controlId="carrierDetails" className="mt-3">
                <Form.Label>Carrier</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isViewMode}
                  {...register("carrier")}
                  isInvalid={!!errors.carrier}
                  placeholder="Enter Carrier"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.carrier?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col lg={3} md={3}>
              <Form.Group controlId="shippingCost" className="mt-3">
                <Form.Label>Shipping Cost</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isViewMode}
                  onKeyDown={handleKeyDown}
                  {...register("shipping_cost")}
                  isInvalid={!!errors.shipping_cost}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shipping_cost?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col lg={3} md={3}>
              <Form.Group className="mb-3 mt-3">
                <Form.Label>Notes</Form.Label>
                <InputGroup>
                  <Form.Control
                    as="textarea"
                    disabled={isViewMode}
                    {...register("notes")}
                    style={{
                      height: "auto",
                      minHeight: "80px",
                      resize: "none",
                    }}
                    onInput={(e) => {
                      e.target.style.height = "auto";
                      e.target.style.height = `${e.target.scrollHeight}px`;
                    }}
                    placeholder="Enter Notes"
                  />
                </InputGroup>
                {errors.notes && (
                  <span className="text-danger">{errors.notes.message}</span>
                )}
              </Form.Group>
            </Col>
            <Col lg={3} md={3}>
              <Form.Group className="mb-3 mt-3">
                <Form.Label>Person's Name</Form.Label>
                <InputGroup>
                  <Form.Select
                    {...register("preffered_email")}
                    disabled={isViewMode}
                  >
                    {/* <option value={""}>Select a method</option> */}
                    <option value={"salesLead"}>Sales Lead</option>
                    <option value={"loggedIn"}>Self</option>
                  </Form.Select>
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  {errors.preffered_email?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <div className="drag_section mt-3">
            {itemFields.map((item, index) => (
              <Card key={item.id} className="mb-3 ">
                <Card.Body>
                  <Row className="grag_flex_row p-3">
                    <Col className="small_drag_column mob_50">
                      <Form.Group>
                        <Form.Label className="">INCLUDE</Form.Label>
                        <Form.Text>
                          <Form.Check
                            type="checkbox"
                            id={`items[${index}].is_selected`}
                            {...register(`items[${index}].is_selected`)}
                            disabled={
                              item.totalqty - item.packaging_slip_quantity ===
                                0 || isViewMode
                            }
                          />
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    {showClin && (
                      <Col className="mid_drag_column mob_50">
                        <Form.Group>
                          <Form.Label className="">CLIN</Form.Label>
                          <InputGroup>
                            <Form.Control
                              {...register(`items[${index}].auto_id`)}
                              defaultValue={item.auto_id}
                              placeholder="CLIN"
                              disabled={true}
                            />
                          </InputGroup>
                          {errors.items?.[index]?.auto_id && (
                            <span className="text-danger">
                              {errors.items[index].auto_id.message}
                            </span>
                          )}
                        </Form.Group>
                      </Col>
                    )}
                    <Col className="mid_drag_column mob_50">
                      <Form.Group>
                        <Form.Label className="">CLIN ID</Form.Label>
                        <InputGroup>
                          <Form.Control
                            {...register(`items[${index}].clin_id`)}
                            defaultValue={item.clin_id}
                            placeholder="CLIN ID"
                            disabled={
                              item.totalqty - item.packaging_slip_quantity ===
                                0 || isViewMode
                            }
                          />
                        </InputGroup>
                        {errors.items?.[index]?.clin_id && (
                          <span className="text-danger">
                            {errors.items[index].clin_id.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>
                    {showClin && (
                      <>
                        <Col className="mid_drag_column mob_50">
                          <Form.Group>
                            <Form.Label className="">Product Name</Form.Label>
                            <InputGroup>
                              <Form.Control
                                {...register(`items[${index}].name`)}
                                defaultValue={item.name}
                                placeholder="Name"
                                disabled={true}
                              />
                            </InputGroup>
                            {errors.items?.[index]?.name && (
                              <span className="text-danger">
                                {errors.items[index].name.message}
                              </span>
                            )}
                          </Form.Group>
                        </Col>
                        <Col className="mid_drag_column mob_50">
                          <Form.Group>
                            <Form.Label className="">Raw Sku ID</Form.Label>
                            <InputGroup>
                              <Form.Control
                                {...register(`items[${index}].raw_sku_id`)}
                                defaultValue={item.raw_sku_id}
                                placeholder="Name"
                                disabled={true}
                              />
                            </InputGroup>
                            {errors.items?.[index]?.raw_sku_id && (
                              <span className="text-danger">
                                {errors.items[index].raw_sku_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </Col>
                      </>
                    )}
                    <Col className="mid_drag_column mob_50">
                      <Form.Group>
                        <Form.Label className="">Product Number</Form.Label>
                        <InputGroup>
                          <Form.Control
                            {...register(`items[${index}].sku_id`)}
                            defaultValue={item.sku_id}
                            placeholder="Part Number"
                            disabled={true}
                          />
                        </InputGroup>
                        {errors.items?.[index]?.sku_id && (
                          <span className="text-danger">
                            {errors.items[index].sku_id.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    <Col className="mob_100">
                      <Form.Group>
                        <Form.Label className="">Item Description</Form.Label>
                        <InputGroup>
                          <Form.Control
                            disabled={
                              item.totalqty - item.packaging_slip_quantity ===
                                0 || isViewMode
                            }
                            as="textarea"
                            {...register(`items[${index}].description`)}
                            defaultValue={item.description}
                            placeholder="Description"
                            ref={(el) => {
                              textAreaRefs.current[index] = el;
                              adjustTextAreaHeight(index);
                            }}
                            style={{
                              resize: "none",
                              overflow: "hidden",
                            }}
                            // onChange={() => adjustTextAreaHeight(index)}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              setValue(`items.${index}.description`, newValue);
                              adjustTextAreaHeight(index);
                            }}
                          />
                        </InputGroup>
                        {errors.items?.[index]?.description && (
                          <span className="text-danger">
                            {errors.items[index].description.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    <Col className="small_drag_column mob_50">
                      <Form.Group style={{ marginTop: "-18px" }}>
                        <Form.Label>
                          QTY{" "}
                          {/* {!isViewMode && (
                            <>
                              (Max:{" "}
                              {item.totalqty - item.packaging_slip_quantity})
                            </>
                          )} */}
                        </Form.Label>

                        {!isViewMode && (
                          <small
                            className="text-muted d-block mb-1"
                            style={{
                              fontSize: "11px",
                              lineHeight: "14px",
                            }}
                          >
                            Max:{" "}
                            {Math.max(
                              (parseFloat(item.totalqty) || 0) -
                                (parseFloat(item.packaging_slip_quantity) || 0),
                              0,
                            )
                              .toFixed(7)
                              .replace(/\.?0+$/, "")}
                          </small>
                        )}
                        <InputGroup>
                          <Form.Control
                            disabled={
                              item.totalqty - item.packaging_slip_quantity ===
                                0 || isViewMode
                            }
                            type="number"
                            step="any"
                            {...register(`items[${index}].quantity`, {
                              valueAsNumber: true,
                            })}
                            defaultValue={item.quantity}
                            placeholder="0"
                            // max={item.totalqty - item.packaging_slip_quantity}
                            max={Number(
                              Math.max(
                                (parseFloat(item.totalqty) || 0) -
                                  (parseFloat(item.packaging_slip_quantity) ||
                                    0),
                                0,
                              ).toFixed(7),
                            )}
                            onChange={(e) => {
                              const qty = parseFloat(e.target.value) || 0;
                              const allowedQty = Number(
                                Math.max(
                                  (parseFloat(item.totalqty) || 0) -
                                    (parseFloat(item.packaging_slip_quantity) ||
                                      0),
                                  0,
                                ).toFixed(7),
                              );
                              // const allowedQty =
                              //   item.totalqty - item.packaging_slip_quantity;
                              const validQty = Number(
                                Math.min(qty, allowedQty).toFixed(7),
                              );
                              // const validQty = Math.min(qty, allowedQty);
                              if (qty > allowedQty) {
                                toast.error(
                                  `Maximum allowed quantity is ${allowedQty}`,
                                );
                                setValue(`items.${index}.quantity`, validQty);
                              } else {
                                setValue(`items.${index}.quantity`, validQty);
                              }
                              const price =
                                parseFloat(
                                  getValues(`items.${index}.customer_price`),
                                ) || 0;
                              const total = roundToMoney(validQty * price);
                              setValue(`items.${index}.total_price`, total);
                            }}
                          />
                        </InputGroup>
                        {errors.items?.[index]?.quantity && (
                          <span className="text-danger">
                            {errors.items[index].quantity.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    <Col className="mob_50">
                      <Form.Group>
                        <Form.Label className="">Unit Price</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <IconCurrencyDollar stroke={2} />
                          </InputGroup.Text>
                          <Form.Control
                            type="number"
                            disabled={true}
                            step="any"
                            {...register(`items[${index}].customer_price`, {
                              valueAsNumber: true,
                            })}
                            defaultValue={item.customer_price}
                            placeholder="0.00"
                          />
                        </InputGroup>
                        {errors.items?.[index]?.customer_price && (
                          <span className="text-danger">
                            {errors.items[index].customer_price.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    <Col className="mob_50">
                      <Form.Group>
                        <Form.Label className="">Total Cost</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <IconCurrencyDollar stroke={2} />
                          </InputGroup.Text>
                          <Form.Control
                            type="number"
                            step="any"
                            disabled={true}
                            {...register(`items[${index}].total_price`, {
                              valueAsNumber: true,
                            })}
                            defaultValue={item.total_price}
                            placeholder="0.00"
                            readOnly
                          />
                        </InputGroup>
                        {errors.items?.[index]?.total_price && (
                          <span className="text-danger">
                            {errors.items[index].total_price.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            ))}
            <div className="totle_costing mt-3">
              <h6>
                Sub Total:
                <span>
                  <IconCurrencyDollar />
                  {truncateFormat(
                    items?.reduce(
                      (sum, item) => sum + (parseFloat(item?.total_price) || 0),
                      0,
                    ) || 0,
                    2,
                  )}
                </span>
              </h6>
            </div>
          </div>

          <div className="mb-3 mt-3">
            {/* Show Generate button only when not in View Mode and something is selected */}
            {!isViewMode && showGen && (
              <>
                <Button
                  variant="secondary"
                  type="button"
                  className="me-2"
                  onClick={handlePreview}
                >
                  Preview <IconFileTypePdf />
                </Button>
                <Button variant="primary" type="submit">
                  Generate <IconFileTypePdf />
                </Button>
              </>
            )}

            {/* Always show Download button in View Mode */}
            {isViewMode && (
              <PDFDownloadLink
                component="button"
                color="secondary"
                document={
                  <PackingSlipPdfDocument
                    invoicedata={viewOnlyRecord}
                    items={getValues("items")}
                    loggedInUser={user}
                  />
                }
                fileName={`${File_Opportunity_Name}${row.order_id}_PackingSlip.pdf`}
              >
                {({ blob, url, loading, error }) => (
                  <span
                    className="btn btn-success ms-2 d-inline-flex align-items-center"
                    style={{ gap: "6px" }}
                  >
                    {loading ? "Loading..." : "Download"}
                  </span>
                )}
              </PDFDownloadLink>
            )}

            {/* Show Download after generating (normal mode) */}
            {!isViewMode && packingSlipClicked && (
              <PDFDownloadLink
                component="button"
                color="secondary"
                document={
                  <PackingSlipPdfDocument
                    invoicedata={packingSlipData}
                    items={getValues("items")}
                    loggedInUser={user}
                  />
                }
                fileName={`${File_Opportunity_Name}${row.order_id}_PackingSlip.pdf`}
              >
                {({ blob, url, loading, error }) => (
                  <span
                    className="btn btn-success ms-2 d-inline-flex align-items-center"
                    style={{ gap: "6px" }}
                  >
                    {loading ? "Loading..." : "Download"}
                  </span>
                )}
              </PDFDownloadLink>
            )}
          </div>

          {/* <div className="mb-3 mt-3">
            {showGen && (
              <>
                <Button variant="primary" type="submit">
                  Generate <IconFileTypePdf />
                </Button>

                {packingSlipClicked && (
                  <PDFDownloadLink
                    component="button"
                    color="secondary"
                    document={
                      <PackingSlipPdfDocument
                        invoicedata={
                          isViewMode ? viewOnlyRecord : packingSlipData
                        }
                        items={getValues("items")}
                        loggedInUser={user}
                      />
                    }
                    fileName={`${File_Opportunity_Name}${row.invoice_no}_PackingSlip.pdf`}
                  >
                    {({ blob, url, loading, error }) => (
                      <span
                        className="btn btn-success ms-2 d-inline-flex align-items-center"
                        style={{ gap: "6px" }}
                      >
                        {loading ? "Loading..." : "Download"}
                      </span>
                    )}
                  </PDFDownloadLink>
                )}
              </>
            )}
          </div> */}
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default PackingSlipComponent;
